<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="微信" name="2">
          <!-- 查询条件 -->
          <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
            <el-row :gutter="35">
              <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
                <el-form-item label="推荐位类型">
                  <el-select placeholder="请选择推荐位类型" v-model="queryParams.type" clearable @change="search" @clear="search">
                    <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
                <div class="btn_left">
                  <el-button size="medium" type="primary" @click="search">查询</el-button>
                  <el-button size="medium" @click="reset">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>

          <!--工具栏 -->
          <div class="div_buttom">
            <el-button size="medium" @click="getList">刷新列表</el-button>
            <el-button size="medium" type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
          </div>

          <!-- 列表 -->
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                    size="medium"
                    :header-cell-style="{textAlign:'center',background:'#f5f7fa'}"
                    :cell-style="{textAlign:'center'}"
                    v-loading="loading"
                    border>
            <el-table-column label="ID" width="60">
              <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column>
            <el-table-column prop="name" label="推荐位名称">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column prop="name" label="推荐位类型">
              <template slot-scope="scope">{{ scope.row.type_text }}</template>
            </el-table-column>
            <el-table-column prop="name" label="排序">
              <template slot-scope="scope">
                <el-tooltip placement="bottom" v-if="showWeight[scope.$index]">
                  <div slot="content" v-html="clickText"></div>
                  <span class="description-span" @click="setToNumber(scope.$index)">{{ scope.row.weigh }}</span>
                </el-tooltip>
                <el-input
                    class="custom-input"
                    v-if="!showWeight[scope.$index]"
                    v-model="scope.row.weigh"
                    @blur="editShowWeight(scope.$index)"
                    @change="editWeight(scope.$index, scope.row)"
                    @input="validateInput(scope.row)"
                    style="width: 40%;"
                    maxlength="5"
                    v-focus
                    :min="0"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="更新时间">
              <template slot-scope="scope">{{ scope.row.updated_at }}</template>
            </el-table-column>
            <el-table-column prop="name" label="资源列表">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="handleBlockResource(scope.row)">资源列表</el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="handleUpdate(scope.row)">编辑</el-button>
                <el-button type="text" style="color: red" size="medium" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <pagination
              v-show="total>0"
              :total="total"
              :page.sync="queryParams.pageNo"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
          />
        </el-tab-pane>
      </el-tabs>

      <EditManageBlock v-if="manageBlockEdit" :manageBlockEdit="manageBlockEdit"
                       @NoneManageBlockFlag="NoneManageBlockFlag" @AddManageBlockok="AddManageBlockok" :editID="editID"
                       :platformType="activeName">
      </EditManageBlock>
    </el-card>
  </div>
</template>
<script>

import {manageBlockAPI} from "@/api/appletlist/manageBlock";
import {processErrors} from "@/utils/errorHandler";
import EditManageBlock from "./editManageBlock.vue";

export default {
  name: "index",
  components: {
    EditManageBlock,
  },
  data() {
    return {
      clickText: "点击编辑",
      // tab栏切换
      activeName: '2',
      showWeight: {},
      tableData: [],
      total: 0,

      queryParams: {
        pageNo: 1,
        pageSize: 10,
        type: '',
      },

      typeList: [
        {id: 1, name: 'Banner'},
        {id: 2, name: '强烈推荐'},
        {id: 3, name: '精品热门'},
        {id: 4, name: '多人收藏'},
        {id: 5, name: '热门榜'},
        {id: 6, name: '新书榜'},
        {id: 7, name: '收藏榜'},
      ],

      loading: true,

      editID: '',
      manageBlockEdit: false,
    }
  },

  created() {
    this.getList();
  },
  methods: {
    editShowWeight(index) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 false
    },
    editWeight(index, data) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 true
      if (data.weigh == null) {
        data.weigh = 0
      }
      let params = {id: data.id, name: data.name, type: data.type, platform_type: data.platform_type, weigh: data.weigh}
      let api = manageBlockAPI()
      api.editManageBlock(params).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: 'success'
          });
          this.$emit('AddOk');
          this.getList();
        } else {
          processErrors(res);
        }
      })
    },
    setToNumber(index) {
      for (let i = 0; i < this.total; i++) {
        this.$set(this.showWeight, i, true);
      }
      this.$set(this.showWeight, index, false); // 设置特定行的状态为 false
    },
    validateInput(row) {
      // 使用正则表达式验证输入值
      const regex = /^[0-9]*$/; // 只允许输入非负整数
      if (!regex.test(row.weight)) {
        // 如果输入不符合要求，重置为0
        row.weight = 0;
      }
    },

    // 点击tab切换
    handleClick(tab, event) {
      this.getList();
    },

    /**
     * 添加
     */
    handleAdd() {
      this.editID = ''
      this.manageBlockEdit = true
    },

    /**
     * 编辑
     * @param row
     */
    handleUpdate(row) {
      this.editID = row.id
      this.manageBlockEdit = true
    },

    /**
     * 删除
     * @param row
     */
    handleDelete(row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id
        }
        let api = manageBlockAPI()
        api.delManageBlock(params).then(res => {
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList();
          } else {
            processErrors(res);
          }
        })
      }).catch(() => {
      });
    },

    NoneManageBlockFlag() {
      this.manageBlockEdit = false
    },

    AddManageBlockok() {
      this.getList()
      this.manageBlockEdit = false
    },

    // 重置按钮
    reset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        type: "",
      }
      this.getList();
    },

    // 点击查询
    search() {
      this.queryParams.pageNo = 1;
      this.getList();
    },

    /**
     * 资源列表
     * @param row
     */
    handleBlockResource(row) {
      this.$router.push({
        path: '/appletlist/manageBlock/blockResource/index',
        query: {
          block_id: row.id,
          type: row.type,
          platform_type: this.activeName
        },
      })
    },

    // 获取列表
    getList() {
      this.loading = true;
      this.tableData = [];
      this.total = 0;
      let api = manageBlockAPI()
      this.queryParams.platform_type = this.activeName
      api.getManageBlockList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
          for (let i = 0; i < this.total; i++) {
            this.$set(this.showWeight, i, true);
          }
          this.loading = false;
        } else {
          processErrors(res);
        }
      })
    },
  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector("input").focus();
      },
    },
  }
}
</script>

<style lang='scss' scoped>
.Box {
  .custom-input ::v-deep .el-input__inner {
    text-align: center;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>